export default __webpack_public_path__ + "static/vision04-41f4236eff833a700cdd96074c41d224.jpg";